import { IconButton, Theme, Tooltip, useMediaQuery } from '@mui/material';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { InfoIcon } from 'assets';
import { SimpleInfoDialog } from 'components';
import { IDialogContext } from 'context';
import { useDialog } from 'hooks';

import styles from './Info.module.scss';

type InfoProps = {
  text?: string;
  children?: JSX.Element;
  tooltipClassName?: string;
  tooltipPlacement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
};

export function Info({ text, children, tooltipClassName, tooltipPlacement = 'right' }: InfoProps) {
  const { i18n } = useTranslation();
  const { showDialog }: IDialogContext = useDialog();
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const resolvedTooltipPlacement = tooltipPlacement === 'right' && i18n.dir() === 'rtl' ? 'left' : tooltipPlacement;

  const handleClick = (): void => {
    if (!isDesktop) {
      const modal = showDialog(SimpleInfoDialog, {
        text,
        children,
        onConfirm: () => {
          modal.destroy();
        },
        classes: { paper: styles.dialog },
      });
    }
  };

  return isDesktop ? (
    <Tooltip
      classes={{ tooltip: classnames(styles.tooltip, tooltipClassName) }}
      title={text ?? children}
      placement={resolvedTooltipPlacement}
    >
      <IconButton className={styles.icon} onClick={handleClick}>
        <InfoIcon color='primary' />
      </IconButton>
    </Tooltip>
  ) : (
    <IconButton className={styles.icon} onClick={handleClick}>
      <InfoIcon color='primary' />
    </IconButton>
  );
}
